module.exports = __webpack_public_path__ + "49c35d1588488c796943a8d42245d1c8.pdf";